import { render, staticRenderFns } from "./active-filters.vue?vue&type=template&id=591f5fc9&scoped=true"
import script from "./active-filters.vue?vue&type=script&lang=js"
export * from "./active-filters.vue?vue&type=script&lang=js"
import style0 from "./active-filters.vue?vue&type=style&index=0&id=591f5fc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591f5fc9",
  null
  
)

export default component.exports